import styled from "styled-components";

/**
 * 公開プロフィールページのセクション見出し（共通スタイル）。
 *
 * Django `.profile__profile` のセクション名と同じ意匠：
 * - 上に区切り線（`border-top: 1px solid var(--soremo-border)`）
 * - `clamp(1.125rem, 0.989rem + 0.68vw, 1.5rem)` のレスポンシブフォント
 * - `line-height: 200%`、`palt` カーニング
 *
 * `ProfileReviews` / `ProfileTextSection` 等で同じ見え方に統一するため共通化している。
 *
 * ブロック見出しは英大文字を基本とする方針のため `text-transform: uppercase`
 * を効かせる（`PROFILE` / `BIOGRAPHY` のような見え方）。ユーザーが設定した
 * テキストブロックのセクション名も表示時に大文字化されるが、これは表示上の
 * 整形だけで保存値は変えない。日本語は uppercase の対象外なのでそのまま出る。
 */
const SectionTitle = styled.div`
  width: 100%;
  border-top: 1px solid var(--soremo-border);
  line-height: 200%;
  font-feature-settings: "palt" on;
  font-size: clamp(1.125rem, 0.989rem + 0.68vw, 1.5rem);
  font-family: "A+mfCv-AXISラウンド 50 R StdN", "M PLUS 1p", sans-serif;
  text-transform: uppercase;
`;

export default SectionTitle;
